<template>
  <YourMovie/>
</template>

<script>
// @ is an alias to /src
import Header from '@/components/Header.vue'
import YourMovie from '@/components/YourMovie.vue';


export default {
  name: 'Generator',
  components: {
    Header,
    YourMovie
  },
}
</script>
